import { Component, OnInit, Inject } from '@angular/core';
import { ErrorStateMatcher, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ConfirmComponent } from '../../../shared/dialogs/confirm/confirm.component';
import { TaxService } from '../../../services/tax.service';

import { AuthService } from '../../../services/auth.service';
import { SnackBarIconService } from '../../../shared/snack-bar-icon/snack-bar-icon.service';
import { Tax } from 'src/app/models/tax';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-tax-dialog',
  templateUrl: './tax-dialog.component.html',
  styleUrls: ['./tax-dialog.component.scss'],
  entryComponents: [
    ConfirmComponent
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' }
  ]
})
export class TaxDialogComponent implements OnInit {

  public local_title: string;
  public matcher = new FormErrorStateMatcher(); // filter table
  public entityForm: FormGroup;   // store User Form
  public isEdit: boolean; // is insert or update
  public spinner: boolean = false;

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private _taxService: TaxService,
    private _authService: AuthService,
    private snackBar: SnackBarIconService,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DIALOG_DATA) public data: Tax
  ) { }


  ngOnInit() {

    this._adapter.setLocale('pt');

    // check is is insert or update
    if (this.data.id != "0") {
      this.isEdit = true;
      this.local_title = "Edição: " + this.data.name
    } else {
      this.isEdit = false
      this.local_title = "Nova Taxa"
    }
    
    this.entityForm = this.createForm()
    this.setFormValues(this.data, this.entityForm)    
  }

  insert() {
    if (this.entityForm.valid) {
      this.spinner = true;
      let entity: Tax = this.createEntity(this.entityForm.value);

      this._taxService.insert(entity)
        .then((result) => {
          this.data.id = result.id
          this.isEdit = true;
          this.entityForm.controls.id.setValue(result.id);
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch((error) => {
          console.log("insert tax error: " + error)
          let msgError: string = this._taxService.makeMsgError(error.details.code)
          this.snackBar.openSnackBar(msgError, '', 'error');
        })
        .finally(() => {
          this.spinner = false
        });
    }

  }

  update() {
    if (this.entityForm.valid) {

      this.spinner = true;
      let entity: Tax = this.createEntity(this.entityForm.value);

      this._taxService.update(entity)
        .then(() => {
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch((error) => {
          console.log("room update error: " + JSON.stringify(error))
          let msgError: string = this._taxService.makeMsgError(error.details.code)
          this.snackBar.openSnackBar(msgError, '', 'error');
        })
        .finally(() => {
          this.spinner = false
        });
    }
  }

  createEntity(data: any): Tax {
    let entity = new Tax();
    entity.id = data.id;
    entity.name = data.name;
    entity.value = Number(data.value);
    return entity;
  }

  setFormValues(data, form) {
    form.controls.id.setValue(data.id);
    form.controls.name.setValue(data.name);
    form.controls.value.setValue(data.value);
  }

  createForm() {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      name: new FormControl('', [Validators.required]),
      value: new FormControl('', [Validators.required])
    });
    return form
  }

}